export default __webpack_public_path__ + "static/admin4-d271ec67960eae05ac90fafab0f8dc8a.png";